<template>
    <form class="-client-add"
          v-on:submit.prevent="submit"
          action="">
        <h3>Personne 1</h3>
        <person-form :data.sync="data1"
                     :id-suffix="'-person1'"></person-form>

        <hr>

        <h3>Personne 2</h3>
        <person-form :data.sync="data2"
                     :id-suffix="'-person2'"></person-form>

        <div class="row">
            <div class="col-sm-12 cta">
                <button type="submit" class="btn btn-primary -add-family">
                    Créer
                </button>
            </div>
        </div>
    </form>
</template>

<script type="text/ecmascript-6">
    import PersonForm from './PersonForm';
    import {dataToContact, makeDefaultData} from './utils';

    export default {
        components: {
            PersonForm
        },
        data() {
            return {
                data1: makeDefaultData('madame'),
                data2: makeDefaultData('monsieur')
            };
        },
        computed: {
            clientData() {
                let familyName = 'Famille ';

                if (this.data1.last_name === this.data2.last_name) {
                    familyName += this.data1.last_name;
                } else {
                    familyName += `${this.data1.last_name}/${this.data2.last_name}`;
                }

                return {
                    name: familyName,
                    type: 'family',
                    status: 'prospect',
                    contacts: [dataToContact(this.data1), dataToContact(this.data2)]
                };
            }
        },
        methods: {
            submit() {
                this.$dispatch('clients:add', this.clientData);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// AddFamily.vue?231be215